import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generalPriceBar'
})
export class GeneralPriceBarPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    }
    return items.filter(item => item.label.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

}
